module.exports = __webpack_public_path__ + "img/lieferando-logo.acb07c45.png";